import React from "react";
// import Top from "../../Top";
// import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
// import CreateIcon from "@mui/icons-material/Create";
// import DeleteIcon from "@mui/icons-material/Delete";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Stack from "@mui/material/Stack";
// import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import TextField from "@mui/material/TextField";
// import CheckIcon from "@mui/icons-material/Check";
// import CloseIcon from "@mui/icons-material/Close";
import Switch from "@mui/material/Switch";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  makePostRequest,
  // makeGetRequest,
  uploadFileRequest,
} from "../../../utils/utils";
import swal from "sweetalert";
// import { first } from "lodash";

const label = { inputProps: { "aria-label": "Size switch demo" } };

const Validation_Schema = Yup.object().shape({
  amenityName: Yup.string().required("Required"),
  // status: Yup.string().required("Required"),
  is_paid: Yup.string(),
  charges: Yup.string().matches(/^\d+$/, "The field should have digits only"),
  duration: Yup.string().required("Required"),
  capacity: Yup.string()
    .matches(/^\d+$/, "The field should have digits only")
    .required("Required"),
});

function AddAmenityForm() {
  // const [value, setValue] = React.useState(dayjs("2014-08-18T21:11:54"));
  // const [is_active, setIsActive] = React.useState(true);

  // const handleChangeStatus = (event) => {
  //   setIsActive(event.target.checked);
  // };

  // const handleChange = (newValue) => {
  //   setValue(newValue);
  // };

  const [amenityName, setAmenityName] = React.useState("");
  const [is_paid, setIsPaid] = React.useState();
  const [is_active, setIsActive] = React.useState(true);
  const [duration, setDuration] = React.useState();
  const [charges, setCharges] = React.useState(0);
  const [description, setDescription] = React.useState();
  const [cancellation_charges, setCancellation_charges] = React.useState();
  const [capacity, setCapacity] = React.useState();
  const [lstAmenityPics, setLstAmenityPics] = React.useState([]);
  const [booking_capacity, setBooking_capacity] = React.useState();
  const [booking_count] = React.useState();
  const [booking_limit, setBooking_limit] = React.useState();

  // const [lstAvailableDays,setAvailableDays]=React.useState([{day:'',availableDayJson:{}}]);

  // const [value, setValue] = React.useState(0);
  const navigate = useNavigate();
  // const [value, setValue] = React.useState(dayjs("2014-08-18T21:11:54"));

  const [mondayStartTime, setMondayStartTime] = React.useState();
  const [mondayEndTime, setMondayEndTime] = React.useState();
  const [isMondayClosed, setIsMondayClosed] = React.useState(false);

  const [tuesdayStartTime, setTuesdayStartTime] = React.useState();
  const [tuesdayEndTime, setTuesdayEndTime] = React.useState();
  const [isTuesdayClosed, setIsTuesdayClosed] = React.useState(false);

  const [wednesdayStartTime, setWednesdayStartTime] = React.useState();
  const [wednesdayEndTime, setWednesdayEndTime] = React.useState();
  const [isWednesdayClosed, setIsWednesdayClosed] = React.useState(false);

  const [thursdayStartTime, setThursdayStartTime] = React.useState();
  const [thursdayEndTime, setThursdayEndTime] = React.useState();
  const [isThursdayClosed, setIsThursdayClosed] = React.useState(false);

  const [fridayStartTime, setFridayStartTime] = React.useState();
  const [fridayEndTime, setFridayEndTime] = React.useState();
  const [isFridayClosed, setIsFridayClosed] = React.useState(false);

  const [saturdayStartTime, setSaturdayStartTime] = React.useState();
  const [saturdayEndTime, setSaturdayEndTime] = React.useState();
  const [isSaturdayClosed, setIsSaturdayClosed] = React.useState(false);

  const [sundayStartTime, setSundayStartTime] = React.useState();
  const [sundayEndTime, setSundayEndTime] = React.useState();
  const [isSundayClosed, setIsSundayClosed] = React.useState(false);

  const [mondaySecondHalfStartTime, setMondaySecondHalfStartTime] =
    React.useState();
  const [mondaySecondHalfEndTime, setMondaySecondHalfEndTime] =
    React.useState();

  const [tuesdaySecondHalfStartTime, setTuesdaySecondHalfStartTime] =
    React.useState();
  const [tuesdaySecondHalfEndTime, setTuesdaySecondHalfEndTime] =
    React.useState();

  const [wednesdaySecondHalfStartTime, setWednesdaySecondHalfStartTime] =
    React.useState();
  const [wednesdaySecondHalfEndTime, setWednesdaySecondHalfEndTime] =
    React.useState();

  const [thursdaySecondHalfStartTime, setThursdaySecondHalfStartTime] =
    React.useState();
  const [thursdaySecondHalfEndTime, setThursdaySecondHalfEndTime] =
    React.useState();

  const [fridaySecondHalfStartTime, setFridaySecondHalfStartTime] =
    React.useState();
  const [fridaySecondHalfEndTime, setFridaySecondHalfEndTime] =
    React.useState();

  const [saturdaySecondHalfStartTime, setSaturdaySecondHalfStartTime] =
    React.useState();
  const [saturdaySecondHalfEndTime, setSaturdaySecondHalfEndTime] =
    React.useState();

  const [sundaySecondHalfStartTime, setSundaySecondHalfStartTime] =
    React.useState();
  const [sundaySecondHalfEndTime, setSundaySecondHalfEndTime] =
    React.useState();

  const [firstStartSelect, setFirstStartSelect] = React.useState(true);
  const [firstEndSelect, setFirstEndSelect] = React.useState(true);

  const [secondHalf_firstStartSelect, setSecondHalf_FirstStartSelect] =
    React.useState(true);
  const [secondHalf_firstEndSelect, setSecondHalf_FirstEndSelect] =
    React.useState(true);
  const [jsonOfDays, setJsonOfDays] = React.useState([]);

  async function handleStartTimeClose() {
    setFirstStartSelect(false);
  }

  async function handleEndTimeClose() {
    setFirstEndSelect(false);
  }

  async function handleSecondHalfStartTimeClose() {
    setSecondHalf_FirstStartSelect(false);
  }

  async function handleSecondHalfEndTimeClose() {
    setSecondHalf_FirstEndSelect(false);
  }

  const handleChangeStartTime = (date, count) => {
    if (firstStartSelect) {
      setMondayStartTime(date);
      setTuesdayStartTime(date);
      setWednesdayStartTime(date);
      setThursdayStartTime(date);
      setFridayStartTime(date);
      setSaturdayStartTime(date);
      setSundayStartTime(date);
    } else {
      if (count === 0) setMondayStartTime(date);
      else if (count === 1) setTuesdayStartTime(date);
      else if (count === 2) setWednesdayStartTime(date);
      else if (count === 3) setThursdayStartTime(date);
      else if (count === 4) setFridayStartTime(date);
      else if (count === 5) setSaturdayStartTime(date);
      else if (count === 6) setSundayStartTime(date);
    }
  };

  const handleChangeEndTime = (date, count) => {
    if (firstEndSelect) {
      setMondayEndTime(date);
      setTuesdayEndTime(date);
      setWednesdayEndTime(date);
      setThursdayEndTime(date);
      setFridayEndTime(date);
      setSaturdayEndTime(date);
      setSundayEndTime(date);
    } else {
      if (count === 0) setMondayEndTime(date);
      else if (count === 1) setTuesdayEndTime(date);
      else if (count === 2) setWednesdayEndTime(date);
      else if (count === 3) setThursdayEndTime(date);
      else if (count === 4) setFridayEndTime(date);
      else if (count === 5) setSaturdayEndTime(date);
      else if (count === 6) setSundayEndTime(date);
    }
  };

  const handleSecondHalfStartTime = (date, count) => {
    if (secondHalf_firstStartSelect) {
      setMondaySecondHalfStartTime(date);
      setTuesdaySecondHalfStartTime(date);
      setWednesdaySecondHalfStartTime(date);
      setThursdaySecondHalfStartTime(date);
      setFridaySecondHalfStartTime(date);
      setSaturdaySecondHalfStartTime(date);
      setSundaySecondHalfStartTime(date);
    } else {
      if (count === 0) setMondaySecondHalfStartTime(date);
      else if (count === 1) setTuesdaySecondHalfStartTime(date);
      else if (count === 2) setWednesdaySecondHalfStartTime(date);
      else if (count === 3) setThursdaySecondHalfStartTime(date);
      else if (count === 4) setFridaySecondHalfStartTime(date);
      else if (count === 5) setSaturdaySecondHalfStartTime(date);
      else if (count === 6) setSundaySecondHalfStartTime(date);
    }
  };

  const handleSecondHalfEndTime = (date, count) => {
    if (secondHalf_firstEndSelect) {
      setMondaySecondHalfEndTime(date);
      setTuesdaySecondHalfEndTime(date);
      setWednesdaySecondHalfEndTime(date);
      setThursdaySecondHalfEndTime(date);
      setFridaySecondHalfEndTime(date);
      setSaturdaySecondHalfEndTime(date);
      setSundaySecondHalfEndTime(date);
    } else {
      if (count === 0) setMondaySecondHalfEndTime(date);
      else if (count === 1) setTuesdaySecondHalfEndTime(date);
      else if (count === 2) setWednesdaySecondHalfEndTime(date);
      else if (count === 3) setThursdaySecondHalfEndTime(date);
      else if (count === 4) setFridaySecondHalfEndTime(date);
      else if (count === 5) setSaturdaySecondHalfEndTime(date);
      else if (count === 6) setSundaySecondHalfEndTime(date);
    }
  };

  const handleChangeDuration = (event) => {
    setDuration(event.target.value);
  };

  const handleChangeIsPaid = (event) => {
    // alert(event.target.value);
    if (event.target.value !== "Free/Paid") setIsPaid(event.target.value);
    if (event.target.value === "Free") {
      document.getElementById("txtPriceId").disabled = true;
      document.getElementById("txtPriceId").value = 0;
      setCancellation_charges(0);
    } else {
      document.getElementById("txtPriceId").disabled = false;
    }
    // else
    //   setIsPaid('Free')
  };

  const handleChangeStatus = (event) => {
    setIsActive(event.target.checked);
  };

  var formikInitials = {
    amenity_name: "",
    is_paid: false,
    status: true,
    capacity: "",
    access_time: "",
    charges: "",
  };

  async function setAvailableDaysData() {
    setJsonOfDays([]);
    if (duration === "Half Day") {
      jsonOfDays.push({
        start_time: mondayStartTime,
        end_time: mondayEndTime,
        second_half_start_time: mondaySecondHalfStartTime,
        second_half_end_time: mondaySecondHalfEndTime,
        isClosed: isMondayClosed,
      });
      jsonOfDays.push({
        start_time: tuesdayStartTime,
        end_time: tuesdayEndTime,
        second_half_start_time: tuesdaySecondHalfStartTime,
        second_half_end_time: tuesdaySecondHalfEndTime,
        isClosed: isTuesdayClosed,
      });
      jsonOfDays.push({
        start_time: wednesdayStartTime,
        end_time: wednesdayEndTime,
        second_half_start_time: wednesdaySecondHalfStartTime,
        second_half_end_time: wednesdaySecondHalfEndTime,
        isClosed: isWednesdayClosed,
      });
      jsonOfDays.push({
        Thursday: {
          start_time: thursdayStartTime,
          end_time: thursdayEndTime,
          second_half_start_time: thursdaySecondHalfStartTime,
          second_half_end_time: thursdaySecondHalfEndTime,
          isClosed: isThursdayClosed,
        },
      });
      jsonOfDays.push({
        start_time: fridayStartTime,
        end_time: fridayEndTime,
        second_half_start_time: fridaySecondHalfStartTime,
        second_half_end_time: fridaySecondHalfEndTime,
        isClosed: isFridayClosed,
      });
      jsonOfDays.push({
        Saturday: {
          start_time: saturdayStartTime,
          end_time: saturdayEndTime,
          second_half_start_time: saturdaySecondHalfStartTime,
          second_half_end_time: saturdaySecondHalfEndTime,
          isClosed: isSaturdayClosed,
        },
      });
      jsonOfDays.push({
        start_time: sundayStartTime,
        end_time: sundayEndTime,
        second_half_start_time: sundaySecondHalfStartTime,
        second_half_end_time: sundaySecondHalfEndTime,
        isClosed: isSundayClosed,
      });
    } else {
      jsonOfDays.push({
        start_time: mondayStartTime,
        end_time: mondayEndTime,
        isClosed: isMondayClosed,
      });
      jsonOfDays.push({
        start_time: tuesdayStartTime,
        end_time: tuesdayEndTime,
        isClosed: isTuesdayClosed,
      });
      jsonOfDays.push({
        start_time: wednesdayStartTime,
        end_time: wednesdayEndTime,
        isClosed: isWednesdayClosed,
      });
      jsonOfDays.push({
        start_time: thursdayStartTime,
        end_time: thursdayEndTime,
        isClosed: isThursdayClosed,
      });
      jsonOfDays.push({
        start_time: fridayStartTime,
        end_time: fridayEndTime,
        isClosed: isFridayClosed,
      });
      jsonOfDays.push({
        start_time: saturdayStartTime,
        end_time: saturdayEndTime,
        isClosed: isSaturdayClosed,
      });
      jsonOfDays.push({
        start_time: sundayStartTime,
        end_time: sundayEndTime,
        isClosed: isSundayClosed,
      });
    }
    setJsonOfDays(jsonOfDays);
  }

  async function addAmenity() {
    await setAvailableDaysData();
    console.log("Json OF Days :" + jsonOfDays);
    let paidVal = "";

    if (is_paid == "Paid") paidVal = "true";
    else paidVal = "false";

    let inputdata = {
      amenity_name: amenityName,
      accessibility: duration,
      available_days: jsonOfDays,
      description: description,
      is_paid: paidVal,
      charges: charges,
      cancellation_charges: cancellation_charges,
      amenity_capacity: capacity,
      booking_capacity: booking_capacity,
      booking_count: booking_count,
      booking_limit: booking_limit,
      status: is_active,
      lstAmenityImages: lstAmenityPics,
      society_id: localStorage.getItem("socityid"),

      // available_days
    };

    makePostRequest("amenities/insert", inputdata)
      .then((response) => {
        if (response.data.status === "1") {
          swal("Success", "Amenity added successfully", "success", {
            timer: 1000,
            buttons: false,
          });
          navigate("/Amenities");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
        console.log("Something went wrong!!", err);
      });
  }

  async function uploadImageOrFile(fileData) {
    const formData = new FormData();
    formData.append("image", fileData);
    var fileUrl;

    await uploadFileRequest("guards/uploadImages", formData).then(
      (response) => {
        fileUrl = response.data.imagepath[0].location;
        console.log(response.data.imagepath[0]);
      }
    );
    alert("File 2" + fileUrl);
    return fileUrl;
  }

  function validateImageOrFile(fileData) {
    if (fileData.name.match(/.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/i))
      return true;
    else return false;
  }

  async function uploadAmenityImages(e) {
    // handle validations
    const file = e.target.files[0];
    var imageUrl = await uploadImageOrFile(file);

    lstAmenityPics.push(imageUrl);
    setLstAmenityPics(lstAmenityPics);
  }

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={formikInitials}
        validationSchema={Validation_Schema}
        onSubmit={addAmenity}
      >
        {({
          values,
          handleChange,
          errors,
          setFieldTouched,
          touched,
          isValid,
          handleSubmit,
        }) => (
          <Form>
            <Grid
              container
              spacing={3}
              className="mainHeadingLine AmenitiesOuterMain"
            >
              <Grid item xs={12} md={12}>
                <div className="addAmeMainDiv">
                  <div className="addAmeMainDivInr">
                    {/* <h2 className="adAmeHed">Add Amenity</h2> */}
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <label className="labSt">Enter Amenity Name</label>
                        <input
                          className="inputSt"
                          type="text"
                          placeholder="Enter Amenity Name"
                          value={values.amenityName}
                          onChange={handleChange("amenityName")}
                          onBlur={() => setFieldTouched("amenityName")}
                          onChangeCapture={(e) =>
                            setAmenityName(e.target.value)
                          }
                        />
                        {errors.amenityName && touched.amenityName ? (
                          <div style={{ color: "red" }} className="errorField">
                            {errors.amenityName}
                          </div>
                        ) : null}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="labSt">Booking duration</label>
                        <select
                          className="inputSt"
                          value={values.duration}
                          onChange={(event) => handleChangeDuration(event)}
                        >
                          <option value={"Hourly"}>Hourly</option>
                          <option value={"Half Day"}>Half Day</option>
                          <option value={"Full Day"}>Full Day</option>
                        </select>
                      </Grid>

                      {/* <Grid item xs={12} md={12}>
                          <label className="labSt">Open days & hours</label>
                          <div className="openNewDayNHrsMain">
                            <Datepicker
                              controls={["time"]}
                              select="range"
                              touchUi={true}
                            />
                          </div>
                        </Grid> */}

                      <Grid item xs={12} md={12}>
                        <label className="labSt">Open days & hours</label>

                        {/* New Timer Design */}
                        <div className="newTimePicMain">
                          <div className="newTimePicDiv">
                            <div className="dayDiv">Monday</div>
                            <div className="dayTimeDiv">
                              <div className="dayTimeInputDiv">
                                <div className="forMultiInptDiv">
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack>
                                      <TimePicker
                                        label="From"
                                        value={mondayStartTime}
                                        onChange={(event) =>
                                          handleChangeStartTime(event, 0)
                                        }
                                        onClose={() => handleStartTimeClose()}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>

                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack>
                                      <TimePicker
                                        label="To"
                                        value={mondayEndTime}
                                        onChange={(event) =>
                                          handleChangeEndTime(event, 0)
                                        }
                                        onClose={() => handleEndTimeClose()}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>
                                </div>

                                {duration == "Half Day" ? (
                                  <div className="forMultiInptDiv">
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <Stack>
                                        <TimePicker
                                          label="From"
                                          value={mondaySecondHalfStartTime}
                                          onChange={(event) =>
                                            handleSecondHalfStartTime(event, 0)
                                          }
                                          onClose={() =>
                                            handleSecondHalfStartTimeClose()
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} />
                                          )}
                                        />
                                      </Stack>
                                    </LocalizationProvider>

                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <Stack>
                                        <TimePicker
                                          label="To"
                                          value={mondaySecondHalfEndTime}
                                          onChange={(event) =>
                                            handleSecondHalfEndTime(event, 0)
                                          }
                                          onClose={() =>
                                            handleSecondHalfEndTimeClose()
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} />
                                          )}
                                        />
                                      </Stack>
                                    </LocalizationProvider>
                                  </div>
                                ) : (
                                  <div></div>
                                )}
                              </div>
                            </div>
                            <div className="forHourly">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <Stack>
                                    <TimePicker
                                      label="Break Time"
                                      value={mondayEndTime}
                                      onChange={(event) =>
                                        handleChangeEndTime(event, 0)
                                      }
                                      onClose={() => handleEndTimeClose()}
                                      renderInput={(params) => (
                                        <TextField {...params} />
                                      )}
                                    />
                                  </Stack>
                                </LocalizationProvider>
                              </div>
                            <div className="dayCloseCheckDiv">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    value={isMondayClosed}
                                    onChange={handleChange("isMondayClosed")}
                                    onBlur={() =>
                                      setFieldTouched("isMondayClosed")
                                    }
                                  />
                                }
                                label="Closed"
                                onChangeCapture={(e) =>
                                  setIsMondayClosed(e.target.value)
                                }
                              />
                            </div>
                          </div>

                          <div className="newTimePicDiv">
                            <div className="dayDiv">Tuesday</div>
                            <div className="dayTimeDiv">
                              <div className="dayTimeInputDiv">
                                <div className="forMultiInptDiv">
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack>
                                      <TimePicker
                                        label="From"
                                        value={tuesdayStartTime}
                                        onChange={(event) =>
                                          handleChangeStartTime(event, 1)
                                        }
                                        onClose={() => handleStartTimeClose()}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>

                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack>
                                      <TimePicker
                                        label="To"
                                        value={tuesdayEndTime}
                                        onChange={(event) =>
                                          handleChangeEndTime(event, 1)
                                        }
                                        onClose={() => handleEndTimeClose()}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>
                                </div>
                                {duration == "Half Day" ? (
                                  <div className="forMultiInptDiv">
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <Stack>
                                        <TimePicker
                                          label="From"
                                          value={tuesdaySecondHalfStartTime}
                                          onChange={(event) =>
                                            handleSecondHalfStartTime(event, 1)
                                          }
                                          onClose={() => handleStartTimeClose()}
                                          renderInput={(params) => (
                                            <TextField {...params} />
                                          )}
                                        />
                                      </Stack>
                                    </LocalizationProvider>

                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <Stack>
                                        <TimePicker
                                          label="To"
                                          value={tuesdaySecondHalfEndTime}
                                          onChange={(event) =>
                                            handleSecondHalfEndTime(event, 1)
                                          }
                                          onClose={() =>
                                            handleSecondHalfEndTimeClose()
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} />
                                          )}
                                        />
                                      </Stack>
                                    </LocalizationProvider>
                                  </div>
                                ) : (
                                  <div></div>
                                )}
                              </div>
                            </div>
                            {/* <div className="forHourly">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <Stack>
                                    <TimePicker
                                      label="Break Time"
                                      value={mondayEndTime}
                                      onChange={(event) =>
                                        handleChangeEndTime(event, 0)
                                      }
                                      onClose={() => handleEndTimeClose()}
                                      renderInput={(params) => (
                                        <TextField {...params} />
                                      )}
                                    />
                                  </Stack>
                                </LocalizationProvider>
                              </div> */}
                            <div className="dayCloseCheckDiv">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    value={isTuesdayClosed}
                                    onChange={handleChange("isTuesdayClosed")}
                                    onBlur={() =>
                                      setFieldTouched("isTuesdayClosed")
                                    }
                                  />
                                }
                                label="Closed"
                                onChangeCapture={(e) =>
                                  setIsTuesdayClosed(e.target.value)
                                }
                              />
                            </div>
                          </div>

                          <div className="newTimePicDiv">
                            <div className="dayDiv">Wednesday</div>
                            <div className="dayTimeDiv">
                              <div className="dayTimeInputDiv">
                                <div className="forMultiInptDiv">
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack>
                                      <TimePicker
                                        label="From"
                                        value={wednesdayStartTime}
                                        onChange={(event) =>
                                          handleChangeStartTime(event, 2)
                                        }
                                        onClose={() => handleStartTimeClose()}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>

                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack>
                                      <TimePicker
                                        label="To"
                                        value={wednesdayEndTime}
                                        onChange={(event) =>
                                          handleChangeEndTime(event, 2)
                                        }
                                        onClose={() => handleEndTimeClose()}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>
                                </div>

                                {duration == "Half Day" ? (
                                  <div className="forMultiInptDiv">
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <Stack>
                                        <TimePicker
                                          label="From"
                                          value={wednesdaySecondHalfStartTime}
                                          onChange={(event) =>
                                            handleSecondHalfStartTime(event, 2)
                                          }
                                          onClose={() =>
                                            handleSecondHalfStartTimeClose()
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} />
                                          )}
                                        />
                                      </Stack>
                                    </LocalizationProvider>

                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <Stack>
                                        <TimePicker
                                          label="To"
                                          value={wednesdaySecondHalfEndTime}
                                          onChange={(event) =>
                                            handleSecondHalfEndTime(event, 2)
                                          }
                                          onClose={() =>
                                            handleSecondHalfEndTimeClose()
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} />
                                          )}
                                        />
                                      </Stack>
                                    </LocalizationProvider>
                                  </div>
                                ) : (
                                  <div></div>
                                )}
                              </div>
                            </div>
                            {/* <div className="forHourly">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <Stack>
                                    <TimePicker
                                      label="Break Time"
                                      value={mondayEndTime}
                                      onChange={(event) =>
                                        handleChangeEndTime(event, 0)
                                      }
                                      onClose={() => handleEndTimeClose()}
                                      renderInput={(params) => (
                                        <TextField {...params} />
                                      )}
                                    />
                                  </Stack>
                                </LocalizationProvider>
                              </div> */}
                            <div className="dayCloseCheckDiv">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    value={isWednesdayClosed}
                                    onChange={handleChange("isWednesdayClosed")}
                                    onBlur={() =>
                                      setFieldTouched("isWednesdayClosed")
                                    }
                                  />
                                }
                                label="Closed"
                                onChangeCapture={(e) =>
                                  setIsWednesdayClosed(e.target.value)
                                }
                              />
                            </div>
                          </div>

                          <div className="newTimePicDiv">
                            <div className="dayDiv">Thursday</div>
                            <div className="dayTimeDiv">
                              <div className="dayTimeInputDiv">
                                <div className="forMultiInptDiv">
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack>
                                      <TimePicker
                                        label="From"
                                        value={thursdayStartTime}
                                        onChange={(event) =>
                                          handleChangeStartTime(event, 3)
                                        }
                                        onClose={() => handleStartTimeClose()}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>

                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack>
                                      <TimePicker
                                        label="To"
                                        value={thursdayEndTime}
                                        onChange={(event) =>
                                          handleChangeEndTime(event, 3)
                                        }
                                        onClose={() => handleEndTimeClose()}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>
                                </div>
                                {duration == "Half Day" ? (
                                  <div className="forMultiInptDiv">
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <Stack>
                                        <TimePicker
                                          label="From"
                                          value={thursdaySecondHalfStartTime}
                                          onChange={(event) =>
                                            handleSecondHalfStartTime(event, 3)
                                          }
                                          onClose={() =>
                                            handleSecondHalfStartTimeClose()
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} />
                                          )}
                                        />
                                      </Stack>
                                    </LocalizationProvider>

                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <Stack>
                                        <TimePicker
                                          label="To"
                                          value={thursdaySecondHalfEndTime}
                                          onChange={(event) =>
                                            handleSecondHalfEndTime(event, 3)
                                          }
                                          onClose={() =>
                                            handleSecondHalfEndTimeClose()
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} />
                                          )}
                                        />
                                      </Stack>
                                    </LocalizationProvider>
                                  </div>
                                ) : (
                                  <div></div>
                                )}
                              </div>
                            </div>

                            {/* <div className="forHourly">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <Stack>
                                    <TimePicker
                                      label="Break Time"
                                      value={mondayEndTime}
                                      onChange={(event) =>
                                        handleChangeEndTime(event, 0)
                                      }
                                      onClose={() => handleEndTimeClose()}
                                      renderInput={(params) => (
                                        <TextField {...params} />
                                      )}
                                    />
                                  </Stack>
                                </LocalizationProvider>
                              </div> */}

                            <div className="dayCloseCheckDiv">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    value={isThursdayClosed}
                                    onChange={handleChange("isThursdayClosed")}
                                    onBlur={() =>
                                      setFieldTouched("isThursdayClosed")
                                    }
                                  />
                                }
                                label="Closed"
                                onChangeCapture={(e) =>
                                  setIsThursdayClosed(e.target.value)
                                }
                              />
                            </div>
                          </div>

                          <div className="newTimePicDiv">
                            <div className="dayDiv">Friday</div>
                            <div className="dayTimeDiv">
                              <div className="dayTimeInputDiv">
                                <div className="forMultiInptDiv">
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack>
                                      <TimePicker
                                        label="From"
                                        value={fridayStartTime}
                                        onChange={(event) =>
                                          handleChangeStartTime(event, 4)
                                        }
                                        onClose={() => handleStartTimeClose()}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>

                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack>
                                      <TimePicker
                                        label="To"
                                        value={fridayEndTime}
                                        onChange={(event) =>
                                          handleChangeEndTime(event, 4)
                                        }
                                        onClose={() => handleEndTimeClose()}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>
                                </div>
                                {duration == "Half Day" ? (
                                  <div className="forMultiInptDiv">
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <Stack>
                                        <TimePicker
                                          label="From"
                                          value={fridaySecondHalfStartTime}
                                          onChange={(event) =>
                                            handleSecondHalfStartTime(event, 4)
                                          }
                                          onClose={() =>
                                            handleSecondHalfStartTimeClose()
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} />
                                          )}
                                        />
                                      </Stack>
                                    </LocalizationProvider>

                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <Stack>
                                        <TimePicker
                                          label="To"
                                          value={fridaySecondHalfEndTime}
                                          onChange={(event) =>
                                            handleSecondHalfEndTime(event, 4)
                                          }
                                          onClose={() =>
                                            handleSecondHalfEndTimeClose()
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} />
                                          )}
                                        />
                                      </Stack>
                                    </LocalizationProvider>
                                  </div>
                                ) : (
                                  <div></div>
                                )}
                              </div>
                            </div>
                            {/* <div className="forHourly">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <Stack>
                                    <TimePicker
                                      label="Break Time"
                                      value={mondayEndTime}
                                      onChange={(event) =>
                                        handleChangeEndTime(event, 4)
                                      }
                                      onClose={() => handleEndTimeClose()}
                                      renderInput={(params) => (
                                        <TextField {...params} />
                                      )}
                                    />
                                  </Stack>
                                </LocalizationProvider>
                              </div> */}
                            <div className="dayCloseCheckDiv">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    value={isFridayClosed}
                                    onChange={handleChange("isFridayClosed")}
                                    onBlur={() =>
                                      setFieldTouched("isFridayClosed")
                                    }
                                  />
                                }
                                label="Closed"
                                onChangeCapture={(e) =>
                                  setIsFridayClosed(e.target.value)
                                }
                              />
                            </div>
                          </div>

                          <div className="newTimePicDiv">
                            <div className="dayDiv">Saturday</div>
                            <div className="dayTimeDiv">
                              <div className="dayTimeInputDiv">
                                <div className="forMultiInptDiv">
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack>
                                      <TimePicker
                                        label="From"
                                        value={saturdayStartTime}
                                        onChange={(event) =>
                                          handleChangeStartTime(event, 5)
                                        }
                                        onClose={() => handleStartTimeClose()}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>

                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack>
                                      <TimePicker
                                        label="To"
                                        value={saturdayEndTime}
                                        onChange={(event) =>
                                          handleChangeEndTime(event, 5)
                                        }
                                        onClose={() => handleEndTimeClose()}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>
                                </div>

                                {duration == "Half Day" ? (
                                  <div className="forMultiInptDiv">
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <Stack>
                                        <TimePicker
                                          label="From"
                                          value={saturdaySecondHalfStartTime}
                                          onChange={(event) =>
                                            handleSecondHalfStartTime(event, 5)
                                          }
                                          onClose={() =>
                                            handleSecondHalfStartTimeClose()
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} />
                                          )}
                                        />
                                      </Stack>
                                    </LocalizationProvider>

                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <Stack>
                                        <TimePicker
                                          label="To"
                                          value={saturdaySecondHalfEndTime}
                                          onChange={(event) =>
                                            handleSecondHalfEndTime(event, 5)
                                          }
                                          onClose={() =>
                                            handleSecondHalfEndTimeClose()
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} />
                                          )}
                                        />
                                      </Stack>
                                    </LocalizationProvider>
                                  </div>
                                ) : (
                                  <div></div>
                                )}
                              </div>
                            </div>
                            {/* <div className="forHourly">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <Stack>
                                    <TimePicker
                                      label="Break Time"
                                      value={mondayEndTime}
                                      onChange={(event) =>
                                        handleChangeEndTime(event, 0)
                                      }
                                      onClose={() => handleEndTimeClose()}
                                      renderInput={(params) => (
                                        <TextField {...params} />
                                      )}
                                    />
                                  </Stack>
                                </LocalizationProvider>
                              </div> */}
                            <div className="dayCloseCheckDiv">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    value={isSaturdayClosed}
                                    onChange={handleChange("isSaturdayClosed")}
                                    onBlur={() =>
                                      setFieldTouched("isSaturdayClosed")
                                    }
                                  />
                                }
                                label="Closed"
                                onChangeCapture={(e) =>
                                  setIsSaturdayClosed(e.target.value)
                                }
                              />
                            </div>
                          </div>

                          <div className="newTimePicDiv">
                            <div className="dayDiv">Sunday</div>
                            <div className="dayTimeDiv">
                              <div className="dayTimeInputDiv">
                                <div className="forMultiInptDiv">
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack>
                                      <TimePicker
                                        label="From"
                                        value={sundayStartTime}
                                        onChange={(event) =>
                                          handleChangeStartTime(event, 6)
                                        }
                                        onClose={() => handleStartTimeClose()}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>

                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack>
                                      <TimePicker
                                        label="To"
                                        value={sundayEndTime}
                                        onChange={(event) =>
                                          handleChangeEndTime(event, 6)
                                        }
                                        onClose={() => handleEndTimeClose()}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>
                                </div>

                                {duration == "Half Day" ? (
                                  <div className="forMultiInptDiv">
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <Stack>
                                        <TimePicker
                                          label="From"
                                          value={sundaySecondHalfStartTime}
                                          onChange={(event) =>
                                            handleSecondHalfStartTime(event, 6)
                                          }
                                          onClose={() =>
                                            handleSecondHalfStartTimeClose()
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} />
                                          )}
                                        />
                                      </Stack>
                                    </LocalizationProvider>

                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <Stack>
                                        <TimePicker
                                          label="To"
                                          value={sundaySecondHalfEndTime}
                                          onChange={(event) =>
                                            handleSecondHalfEndTime(event, 6)
                                          }
                                          onClose={() =>
                                            handleSecondHalfEndTimeClose()
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} />
                                          )}
                                        />
                                      </Stack>
                                    </LocalizationProvider>
                                  </div>
                                ) : (
                                  <div></div>
                                )}
                              </div>
                            </div>
                            {/* <div className="forHourly">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <Stack>
                                    <TimePicker
                                      label="Break Time"
                                      value={mondayEndTime}
                                      onChange={(event) =>
                                        handleChangeEndTime(event, 0)
                                      }
                                      onClose={() => handleEndTimeClose()}
                                      renderInput={(params) => (
                                        <TextField {...params} />
                                      )}
                                    />
                                  </Stack>
                                </LocalizationProvider>
   
                                
                                
                              </div> */}
                            <div className="dayCloseCheckDiv">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    value={isSundayClosed}
                                    onChange={handleChange("isSundayClosed")}
                                    onBlur={() =>
                                      setFieldTouched("isSundayClosed")
                                    }
                                  />
                                }
                                label="Closed"
                                onChangeCapture={(e) =>
                                  setIsSundayClosed(e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                        {/* End */}
                      </Grid>

                      <Grid item xs={12} md={12}>
                        <label className="labSt">Description</label>
                        <textarea
                          className="textAriaSt"
                          placeholder="Type here"
                          onChange={handleChange("description")}
                          onBlur={() => setFieldTouched("description")}
                          onChangeCapture={(e) =>
                            setDescription(e.target.value)
                          }
                        ></textarea>
                        {errors.description && touched.description ? (
                          <div style={{ color: "red" }} className="errorField">
                            {errors.description}
                          </div>
                        ) : null}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="labSt">Free/Paid</label>
                        <select
                          className="inputSt"
                          value={is_paid}
                          onChange={(event) => handleChangeIsPaid(event)}
                        >
                          <option value={"Free"}>Free</option>
                          <option value={"Paid"}>Paid</option>
                        </select>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="labSt">Price</label>
                        <input
                          className="inputSt"
                          id="txtPriceId"
                          type="text"
                          placeholder="Enter Charges"
                          value={values.charges}
                          onChange={handleChange("charges")}
                          onBlur={() => setFieldTouched("charges")}
                          onChangeCapture={(e) => setCharges(e.target.value)}
                          disabled
                        />
                        {errors.charges && touched.charges ? (
                          <div style={{ color: "red" }} className="errorField">
                            {errors.charges}
                          </div>
                        ) : null}
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <label className="labSt">Cancellation fee</label>
                        <input
                          className="inputSt"
                          type="text"
                          placeholder="Cancellaion Fee"
                          value={values.cancellation_charges}
                          onChange={handleChange("cancellation_charges")}
                          onBlur={() => setFieldTouched("cancellation_charges")}
                          onChangeCapture={(e) =>
                            setCancellation_charges(e.target.value)
                          }
                        />
                        {errors.cancellation_charges &&
                        touched.cancellation_charges ? (
                          <div style={{ color: "red" }} className="errorField">
                            {errors.cancellation_charges}
                          </div>
                        ) : null}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="labSt">Amenity Capacity</label>
                        <p className="labelDiscr">(Demo text here)</p>
                        <input
                          className="inputSt"
                          type="text"
                          placeholder="Enter Capacity"
                          value={values.capacity}
                          onChange={handleChange("capacity")}
                          onBlur={() => setFieldTouched("capacity")}
                          onChangeCapture={(e) => setCapacity(e.target.value)}
                        />
                        {errors.capacity && touched.capacity ? (
                          <div style={{ color: "red" }} className="errorField">
                            {errors.capacity}
                          </div>
                        ) : null}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="labSt">Booking Capacity</label>
                        <p className="labelDiscr">(Demo text here)</p>
                        <input
                          className="inputSt"
                          type="text"
                          placeholder="Enter Booking Capacity"
                          value={values.booking_capacity}
                          onChange={handleChange("booking_capacity")}
                          onBlur={() => setFieldTouched("booking_capacity")}
                          onChangeCapture={(e) =>
                            setBooking_capacity(e.target.value)
                          }
                        />
                        {errors.booking_capacity && touched.booking_capacity ? (
                          <div style={{ color: "red" }} className="errorField">
                            {errors.booking_capacity}
                          </div>
                        ) : null}
                      </Grid>
                      {/*
                        
                        <Grid item xs={12} md={6}>
                          <label className="labSt">Booking count</label>
                          <input
                            className="inputSt"
                            type="text"
                            placeholder="Enter Booking Count"
                            value={values.booking_count}
                            onChange={handleChange("booking_count")}
                            onBlur={() => setFieldTouched("booking_count")}
                            onChangeCapture={(e) =>
                              setBooking_count(e.target.value)
                            }
                          />
                          {errors.booking_count && touched.booking_count ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.booking_count}
                            </div>
                          ) : null}
                          
                        </Grid> */}
                      <Grid item xs={12} md={6}>
                        <label className="labSt">Booking limit in a week</label>
                        <p className="labelDiscr">(Demo text here)</p>

                        <input
                          className="inputSt"
                          type="text"
                          placeholder="Booking Limit"
                          value={values.booking_limit}
                          onChange={handleChange("booking_limit")}
                          onBlur={() => setFieldTouched("booking_limit")}
                          onChangeCapture={(e) =>
                            setBooking_limit(e.target.value)
                          }
                        />
                        {errors.booking_limit && touched.booking_limit ? (
                          <div style={{ color: "red" }} className="errorField">
                            {errors.booking_limit}
                          </div>
                        ) : null}
                        {/* <select className="inputSt">
                            <option>Booking limit 1</option>
                            <option>Booking limit 2</option>
                          </select> */}
                      </Grid>
                      <Grid item xs={12} md={6} className="switchMain">
                        <label className="labSt">Active/ Inactive</label>
                        <Switch
                          {...label}
                          checked={is_active}
                          size="small"
                          onChange={(event) => handleChangeStatus(event)}
                        />
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="upImDiv">
                          {lstAmenityPics.map((option, index) => (
                            <div className="uploadedImView">
                              <img src={option} />
                            </div>
                          ))}

                          <div className="forUploadBt">
                            <FileUploadIcon />
                            <input
                              type="file"
                              id="lstAmenityPics"
                              value={values.lstAmenityPics}
                              onChange={(event) => uploadAmenityImages(event)}
                            />
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="modalMainBtMain">
                          <Button className="modalMainBt" onClick={addAmenity}>
                            Add
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default AddAmenityForm;
